module.exports = __webpack_public_path__ + "media/images/dashboard_icons/reward-df0b4cf002e922caa09a45d1741f2191.svg";